import { gql } from '@apollo/client';
import React from 'react';
import { sortBy } from 'ramda';
import classNames from 'classnames';
import { ColorSwatch } from '@moda/om';
import { ColorSelectorFragment } from '../../generated/types/ColorSelectorFragment';
import { isDiscounted } from '../../lib/variantUtils/isDiscounted';
import './ColorSelector.scss';

export const COLOR_SELECTOR_VARIANT_FRAGMENT = gql`
  fragment ColorSelectorVariantFragment on VariantData {
    id
    color
    soldOut: sold_out
    prices(country_code: $countryCode) {
      originalPrice: original_price {
        price
      }
      currentPrice: current_price {
        price
      }
    }
  }
`;

export const COLOR_SELECTOR_FRAGMENT = gql`
  fragment ColorSelectorFragment on Variant {
    masterVariant: master_variants_data {
      ...ColorSelectorVariantFragment
    }
    otherVariants: other_variants_data {
      ...ColorSelectorVariantFragment
    }
  }
  ${COLOR_SELECTOR_VARIANT_FRAGMENT}
`;

interface Props {
  size?: 'default' | 'small';
  variant: ColorSelectorFragment;
  onSelect(color: string): void;
  onMouseEnter?(color: string): void;
  onMouseLeave?(): void;
  selected?: string | null;
  className?: string;
}

export const ColorSelector: React.FC<Props> = ({
  size,
  variant,
  onSelect,
  onMouseEnter,
  onMouseLeave,
  selected,
  className
}) => {
  const colors = sortBy(variant => variant?.id || 0, [
    variant.masterVariant,
    ...variant.otherVariants
  ]).map(
    variation =>
      variation?.color && {
        value: variation.color,
        id: variation.id,
        soldOut: variation.soldOut,
        prices: variation.prices
      }
  );

  return (
    <div className={classNames('ColorSelector', className)}>
      {colors.map(color => {
        return (
          color && (
            <ColorSwatch
              size={size}
              className="ColorSelector__swatch"
              onClick={onSelect}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              key={color.id}
              color={color.value}
              title={color.value}
              soldOut={color.soldOut}
              selected={color.value === selected}
              onSale={isDiscounted(color.prices)}
            />
          )
        );
      })}
    </div>
  );
};
